<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Page',
})
</script>
<template>
  <div v-if="item" style="min-height: 100vh;" class="flex-column align-center justify-center">
      <section style="width: 100%;" :class="item.classname" :style="{backgroundColor:item.background,backgroundImage:'url('+addip(item.backgroundimg)+')',color:item.color}">
          <div :class="item.fullwidth>0?'full-container':'auto-container'">
            <component :is="resolveComponent(item.classname)" :data="item"></component>
          </div>
        </section>
  </div>
</template>

<script lang="ts" setup name="Page">
import { onMounted, ref,resolveComponent } from 'vue';
import { useRoute } from 'vue-router';
import api from '@/utils/http/service';
import {addip} from '@/utils/util'
import { onBeforeMount } from 'vue';
  const route = useRoute();
  const id = ref(route.query.id);
  const item=ref<Object>(null)
  onMounted(()=>{
      api.sitepage.pagesection(route.query).then(res=>{
        console.info(id.value,res.data)
            item.value=res.data
      })
  })

</script>
<style lang="less">
</style>
